var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCardIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1455_20501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.73236 14.1719C5.3216 14.1719 2.55664 16.9368 2.55664 20.3476V35.7034C2.55664 37.2304 4.1608 38.2259 5.52909 37.548L10.5149 35.0779C11.3671 34.6556 12.3054 34.4359 13.2565 34.4359H24.3284C27.7392 34.4359 30.5042 31.671 30.5042 28.2602V20.3476C30.5042 16.9368 27.7392 14.1719 24.3284 14.1719H8.73236Z",
    fill: "url(#paint0_linear_1455_20501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2383 24.3026C10.2383 23.6032 10.8053 23.0361 11.5048 23.0361C12.2043 23.0361 12.7713 23.6032 12.7713 24.3026C12.7713 25.0021 12.2043 25.5691 11.5048 25.5691C10.8053 25.5691 10.2383 25.0021 10.2383 24.3026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3086 24.3026C15.3086 23.6032 15.8756 23.0361 16.5751 23.0361C17.2746 23.0361 17.8416 23.6032 17.8416 24.3026C17.8416 25.0021 17.2746 25.5691 16.5751 25.5691C15.8756 25.5691 15.3086 25.0021 15.3086 24.3026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3711 24.3041C20.3711 23.6046 20.9381 23.0376 21.6376 23.0376C22.3371 23.0376 22.9041 23.6046 22.9041 24.3041C22.9041 25.0036 22.3371 25.5706 21.6376 25.5706C20.9381 25.5706 20.3711 25.0036 20.3711 24.3041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6619 4.58691C25.3135 4.58691 20.9189 8.40941 17.9433 11.9906C17.354 12.6999 17.354 13.7225 17.9433 14.4318C20.9189 18.0129 25.3135 21.8355 29.6619 21.8355C34.0093 21.8355 38.2694 18.0146 41.2174 14.4342C41.8035 13.7223 41.8035 12.7001 41.2174 11.9882C38.2694 8.40768 34.0093 4.58691 29.6619 4.58691Z",
    fill: "url(#paint1_linear_1455_20501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8381 8.4209C27.1934 8.4209 25.0469 10.5674 25.0469 13.2122C25.0469 15.857 27.1934 18.0034 29.8381 18.0034C32.4829 18.0034 34.6294 15.857 34.6294 13.2122C34.6294 10.5674 32.4829 8.4209 29.8381 8.4209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2031 13.2123C27.2031 11.7578 28.3823 10.5786 29.8368 10.5786C31.2914 10.5786 32.4705 11.7578 32.4705 13.2123C32.4705 14.6669 31.2914 15.846 29.8368 15.846C28.3823 15.846 27.2031 14.6669 27.2031 13.2123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5137,
    y: 2.52734,
    width: 25.1331,
    height: 2.05857,
    rx: 1.02929,
    transform: "rotate(45 21.5137 2.52734)",
    fill: "#7171B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_20501",
    x1: 6.15914,
    y1: 14.8795,
    x2: 28.8034,
    y2: 33.9213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#6F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1455_20501",
    x1: 23.6609,
    y1: 7.67477,
    x2: 41.1588,
    y2: 24.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A634FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1455_20501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.23,
    height: 43.23,
    fill: "white",
    transform: "translate(0.384766 0.46875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCardIcon7);
export default __webpack_public_path__ + "static/media/message_card_icon7.3b7ffb1ee36509afae6b82093475c843.svg";
export { ForwardRef as ReactComponent };